<template>
  <div>
    <navigation-side-view
      :isSidebarActive="isNavigationSidebarActive"
      @closeSidebar="toggleDataSidebar"
    />
    <div class="vx-row">
      <div class="vx-col w-1/2 mb-base layout--abc">
        <vx-card slot="no-body" class="text-center greet-user">
          <feather-icon
            icon="DollarSignIcon"
            class="p-6 mb-8 bg-secondary inline-flex rounded-full text-white shadow"
            svgClasses="h-8 w-8"
          ></feather-icon>
          <h1 v-if="$auth.checkRoles(['ABCReaders', 'Admin'])" class="mb-6">
            <router-link to="/abc/kpi/opex">{{ $t("ABC.OPEX.Title") }}</router-link>
          </h1>
          <menu-control :items="abcItems"></menu-control>
          <!-- <v-nav-menu :navMenuItems="navMenuItems" title="TEST" parent=".layout--abc"/> -->
        </vx-card>
      </div>
      <div class="vx-col w-1/2">
        <vs-row vs-type="flex" vs-justify="flex-end">
          <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="12">
            <feather-icon icon="NavigationIcon" class="p-4 mb-4 bg-secondary cursor-pointer rounded-full text-white shadow" svg-classes="h-6 w-6"  @click.stop="toggleDataSidebar(true)" />
          </vs-col>
        </vs-row>
      </div>
    </div>
  </div>
</template>
<script>

import navigationSideView from './components/navigationSideView.vue'
import menuControl from '@/app/shared/components/lists/menu.vue'
import abcRoles from './roles.js'

export default {
  components: {
    navigationSideView,
    menuControl
  },
  data() {
    return {
      // Data Sidebar
      isNavigationSidebarActive: false,
      abcItems : [ 
        {
          roles : abcRoles.readers,
          icon : "ClockIcon",
          to : "/abc/kpi/opex/ugmining",
          i18nTitle : "ABC.OPEX.UGMining"
        },
        {
          roles : abcRoles.readers,
          faIcon : "vial",
          to : "/abc/kpi/opex/ugmining/development",
          i18nTitle : "ABC.Development.Title"
        },
        {
          roles : abcRoles.readers,
          icon : "TargetIcon",
          to : "/abc/kpi/opex/ugmining/development/drilling",
          i18nTitle : "ABC.Development.Drilling"
        }
      ]
    };
  },
  methods: {
    toggleDataSidebar(val = false) {
      this.isNavigationSidebarActive = val;
    }
  }
};
</script>


<style lang="scss">
.vx-timeline {
    margin-left: 3.5rem;
    padding-left: 40px;
    border-left: 2px solid #E5E8EB;

    li {
        position: relative;
        margin-bottom: 40px;

        .timeline-icon {
            position: absolute;
            top: 0;
            left: -4.3rem;
            border-radius: 50%;
            padding: .75rem;
            padding-bottom: 0.4rem;
        }

        .timeline-info {
          text-align: left;
          padding-top:0.4rem;
        }

        .activity-desc {
            font-size: .9rem;
        }

        .activity-e-time {
            font-size: .8rem;
        }
    }
}
</style>